module.exports = __webpack_public_path__ + "media/img/corporate/logos/loreal-95d87ef87e6dec066a03858b87981770.svg";